import React from 'react';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import _isEmpty from 'lodash-es/isEmpty';
import { useTranslation } from 'react-i18next';
import { GradeSelector } from 'containers/MesAnneesScolaires/School/New/GradeSelector';
import { useScholarSystem } from 'queries/user/useScholarSystem';
import { ScholarSystems } from 'containers/scholarSystem';
import { getDefaultWorkingDays } from 'containers/useCountries';

export function Classes() {
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding']);
  const { data: demarrageData } = useDemarrage();
  const { scholarSystem = ScholarSystems.FR } = useScholarSystem(
    demarrageData?.userCountryCode,
  );
  if (!demarrageData) {
    return null;
  }
  const niveaux = demarrageData?.degreesWithWorkingDays || [];
  const defaultWorkingDays = getDefaultWorkingDays(
    demarrageData.userCountryCode,
  );
  const gradeOptions = Object.values(
    scholarSystem.niveaux.filter(n => {
      if (
        demarrageData.userRoles?.includes('1er degré') ||
        demarrageData.userRoles?.includes('directeur') ||
        demarrageData.userRoles?.includes('etudiant crpe')
      ) {
        return n.category !== 'Collège';
      }
      if (demarrageData.userRoles?.includes('2nd degré')) {
        return n.category !== 'Maternelle' && n.category !== 'Élémentaire';
      }
      return true;
    }),
  ).map(n => n.niveau);

  return (
    <StepWrapper
      title={t('onboarding:classes.title')}
      currentStep="classes"
      nextDisabled={_isEmpty(niveaux)}
    >
      <GradeSelector
        groupedOptions={[[...gradeOptions]]}
        value={niveaux.map(n => n.degree)}
        onChange={async v => {
          await update({
            degreesWithWorkingDays: v.map(degree => ({
              workingDays: defaultWorkingDays,
              degree,
            })),
          });
        }}
      />
    </StepWrapper>
  );
}
